import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./circle.css.ts.vanilla.css-mistica.js";
var r = "_1wpwyyp1 _1y2v1nfb5 _1y2v1nfbk _1y2v1nfbe _1y2v1nfdo";
export { r as circle };
